import { themeObject as theme } from '../../../lib';

export const styles = {
    container: {
        px: '1rem',
        width: '100%',
        height: 'inherit',
        display: 'flex',
        my: 'auto',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
    },
    progressBar: {
        backgroundColor: '#E7ECEE', // this is the leftover remainder part of the bar
        height: '40px',
        borderRadius: '10px',
        display: 'block',
        // Target the filled/active part here:
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#8FE9E3',
        },
    },
    progressBarError: {
        backgroundColor: theme.palette.error.light, // Track color when error
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#D53338',
        },
    },
    barText: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
    },
    normalText: {
        color: theme.palette.text.primary,
        fontFamily: 'Red Hat Text',
        fontSize: '18px',
        lineHeight: 'normal',
    },
    errorText: {
        color: '#FFFFFF',
        fontFamily: 'Red Hat Text',
        fontSize: '18px',
        lineHeight: 'normal',
    },
};

export type DateInput = Date | string;

export const clamp = (value: number, min: number, max: number): number =>
    Math.min(Math.max(value, min), max);

export const toTimestamp = (date: DateInput): number => {
    if (date instanceof Date) return date.getTime();
    return new Date(date).getTime();
};
